import React from 'react'

import classes from './footer.css'

const Footer = () => {
	return (
		<div className={classes.Footer}>
			<div className={classes.FooterLeft}>
				<div>Daniel E. Esposito, M.D., D.M.D., FACS</div>
				<div>Implant and Oral Surgery Center of Littleton</div>
			</div>

			<div className={classes.FooterRight}>
				<div>6179 South Balsam Way, Suite 100, Littleton CO., 80123</div>
				<div>(303) 933-8282 FAX (303) 948-5610</div>
			</div>
		</div>
	)
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/UI/Footer/Footer.js